<template>
  <div id="dy">
      <div class="d-flex pt-2 pl-2">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">交易动态</span>
        </span>

      </div>
      <div class="d-flex jc-center body-box" style="height: 90%;width: 100%; margin-top: 0.1rem;">
<!--        <dv-scroll-board :config="config" style="width:100%;height: 3rem" />-->
        <div class="head">
          <span class="col">订单编号</span>
          <span class="col">交易金额(元)</span>
          <span class="col">交易时间</span>
        </div>
          <div class="slideBox" style="height: 85%">
            <!-- slides -->
            <div class="bd">
              <ul>
                <li v-for="(item,index) in dataList" :key="index">
                 <a>{{item.id}}</a>
                  <a>{{item.totalPrices}}</a>
                  <span>{{item.orderCreateTime}}</span>
                </li>
              </ul>
            </div>
          </div>
      </div>
    </div>
</template>
<!-- import JavaScript -->
<script src="https://unpkg.com/vue-superslide/lib/vue-superslide.umd.min.js"></script>

<script>
import sciApi from '@/api/index.js'
// import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      videoUrl:'',
      dataList:[],
      config: {
      },

    };
  },

  computed: {
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init(){
      await sciApi.selectTest({}).then((data)=>{
        this.dataList = data.list || []
        setTimeout(function (){
          $(".slideBox").slide({
            titCell:".hd ul",
            mainCell:".bd ul",
            effect:"topLoop",
            autoPlay:true,
            vis:4,
          });
        },200)

      })
    }
  }
};
</script>

<style lang="scss">
#dy {
  padding: 0.2rem;
  height:100%;
  width:100%;
  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: 4.5rem;
    border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    //border-radius: 0.125rem;
    overflow: hidden;
  }
  .head{
    background: rgba(255, 255, 255, 0.1);
    font-size: 18px;
    height: auto;
    padding: 0.2rem;
    color: #68d8fe;
    display: flex;
    justify-content: space-between;line-height: 1.05;
  }
  .slideBox ul li{
    line-height: 36px;
    height: 36px;
    font-size: 16px;
    color:#4c9bfd;
    //padding: 0 0.2rem;
  }
  .slideBox ul li a{
    color:#4c9bfd!important;
    line-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width: 33%;
    text-align: center;
    float: left;
  }
  .slideBox ul li span{
    float: right;
    line-height: 40px;
    padding-right: 0.1rem;
  }
}
</style>